module.exports = __webpack_public_path__ + "img/BI4.101ad1da.png";